// Pure string/formatting utils shared by both apps (admin + embed).
// Moved out of admin-controls.ts in paso 13 of the panel-contract
// migration so they survive the deletion of the legacy row* builders.

export function escapeAttr(s: string): string {
  return (s ?? '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
}

/** Canonical HTML escaper — the single implementation for both apps
 *  (admin + embed). Escapes the full XSS-relevant set (& < > " ')
 *  so callers that only need the basics stay safe by construction. */
export function escHtml(s: string): string {
  return (s ?? '').replace(/[&<>"']/g, (c) => (
    c === '&' ? '&amp;' :
    c === '<' ? '&lt;'  :
    c === '>' ? '&gt;'  :
    c === '"' ? '&quot;' :
                '&#39;'
  ));
}

export function fmtCoords(lat: number, lon: number): string {
  const latStr = `${Math.abs(lat).toFixed(4)}°${lat >= 0 ? 'N' : 'S'}`;
  const lonStr = `${Math.abs(lon).toFixed(4)}°${lon >= 0 ? 'E' : 'W'}`;
  return `${latStr}, ${lonStr}`;
}
